import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 gap-4">
          <div>
            <span className="inline-block text-xs font-medium text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
              分类浏览
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              探索你喜欢的题材
            </h2>
          </div>
          <Link
            to="/category/rexue"
            className="text-sm text-foreground-500 hover:text-foreground-700 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {comicCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="relative group rounded-xl overflow-hidden h-40 md:h-48 bg-gradient-to-br from-background-100 to-background-200 hover:from-primary-50 hover:to-primary-100 transition-all duration-300"
            >
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-background-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                  <i className={`${cat.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-900 font-bold group-hover:text-primary-700 transition-colors">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-400 mt-1">{cat.count} 部作品</span>
              </div>
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}